import React, { useEffect, useState, useContext } from "react";
import { Icon } from "@iconify/react";
import _ from "lodash";
import { PLANES_DATA } from "../data/planes";
import { useQueryParams } from "../../../hooks/useQueryParams";
import useObtenerSubsecciones from "../../../js/translations/useObtenerSubsecciones";
import { Breadcrumbs } from "../../../components/shared/breadcrums";
import { Accordion } from "../../../components/shared/accordion";
import { PaymentButton } from "../components/payment-button";
import ReactPixel from 'react-facebook-pixel';
import { usePaymentHandler } from "../../hooks/use-payment-handler";
import { useId } from "../../../hooks/use-id";
import useIsMobile from "../../../js/utilities/useIsMobile";


/**
 * Este componente renderiza la pantalla de mi colección en la tienda. 
 * Su principal función es identificar el plan, es decir si es mensual o trimestral,  
 * para mostrar la información correspondiente.
 * @returns PlanMiColeccion
 */
export const PlanMiColeccion = () => {
    const { isReady, textosSubSecciones: textos } = useObtenerSubsecciones('tienda_makemake');
    const params = useQueryParams();
    const [mostrarContenido, setMostrarContenido] = useState();
    const [tipoColeccion, setTipoColeccion] = useState();

    const titleId = useId('plan-mi-coleccion');

    const isMobile = useIsMobile();
    const myCollection = { ...PLANES_DATA.trimestral.find(plan => plan.id === 'mi-coleccion-trimestral') };
	const paymentHandler = usePaymentHandler();

    /**
     * Según el parametro 'Tipo' del path de la Url, se carga la información y el contenido  correspondiente
     */
    useEffect(() => {
        const tipo = params.get('tipo');
        setTipoColeccion(tipo)
        const cargarContenido = myCollection;
        if (isReady) {
            setMostrarContenido(contenidoColeccion(cargarContenido, textos))
        }
    }, [params, isReady, textos])


    /**
     * Esta función ernderiza el contenido según el tiempo elegido, es decir mensual o trimestral
     * @param {object} coleccion - hace referencia al objeto que contiene la información de colección
     * @param {object} textos - objeto de los textos de interfaz
     * @returns contenidoColeccion
     */
    const contenidoColeccion = (coleccion, textos) => {
        const listaIdeal = coleccion?.idealPara || [];
        let loading = false;

        const QuestionAccordion = () => {
            return <Accordion.Container>
                {
                    coleccion.preguntasFrecuentes.map((item, i) => {
                        return (
                            <Accordion.Item key={i} itemId={`item-${i}`}>
                                <Accordion.ItemButton label={_.get(textos, item?.pregunta?.translationPath) || item?.pregunta?.default || 'N/A'} />
                                <Accordion.Content>
                                    <p className="onbackground-primary--color">
                                        {
                                            item?.respuesta?.html ?
                                                <span dangerouslySetInnerHTML={{ __html: _.get(textos, item?.respuesta?.translationPath) || item?.respuesta?.default || 'N/A' }}></span>
                                                :
                                                <>{_.get(textos, item?.respuesta?.translationPath) || item?.respuesta?.default || 'N/A'}</>
                                        }
                                    </p>
                                </Accordion.Content>
                            </Accordion.Item>

                        )
                    })
                }
            </Accordion.Container>
        }

        return (
            <>
                <div className="plan-section-layout mi-coleccion">
                    <div className="d-lg-flex justify-content-between">
                        <div className="sidenav " >
                            <h1 className="title" id={titleId}>
                                {_.get(textos, coleccion?.nombre?.translationPath) || coleccion?.nombre?.default || 'N/A'}
                            </h1>
                            <div className="details">
                                {
                                    coleccion?.detalles?.map((detalle, i) => {
                                        return <p className="detail" key={i}>
                                            <Icon className="icon" icon="mdi:check-bold" />
                                            {
                                                detalle?.html ?
                                                    <span dangerouslySetInnerHTML={{ __html: _.get(textos, detalle?.translationPath) || detalle?.default || 'N/A' }}></span>
                                                    :
                                                    <>{_.get(textos, detalle?.translationPath) || detalle?.default || 'N/A'}</>
                                            }
                                        </p>
                                    })
                                }
                            </div>
                            <div className="desktop-accordion" aria-hidden={isMobile ? true : false}>
                                {QuestionAccordion()}
                            </div>
                        </div>
                        <div className="content_layout">
                            <div className="collection-card d-xl-flex">
                                <div className="blue-plan img-coleccion col-xl-7 px-0 order-lg-2">
                                        <div
                                            className="img"
                                            aria-hidden={true}
                                            role="presentation"
                                            style={{ backgroundImage: `url(${coleccion?.imgUrl?.normal || '/img/no-imagen3.png'}) ` }}></div>
                                    </div>
                                <div className="col-xl-5 p-0 order-lg-1">
                                    <div className="text-background py-3">
                                        <h2 className="mx-auto text-center "> {_.get(textos, coleccion?.nombre?.translationPath) || coleccion?.nombre?.default || 'N/A'}</h2>
                                    </div>
                                    <div className="p-3">
                                        <h3 className="p-3 onprimary--color">{_.get(textos, coleccion?.descripcionFicha?.translationPath) || coleccion?.descripcionFicha?.default || 'N/A'}</h3>
                                        <p className="p-3 ideal">{textos?.individual?.interfaz?.ideal}</p>
                                        <ul className="p-3">
                                            {listaIdeal.map((item, i) => {
                                                return (
                                                    <li key={`list-${i}`}>{_.get(textos, item?.translationPath) || item?.default || 'N/A'}</li>
                                                )
                                            })}
                                        </ul>
                                        {coleccion?.extraInformation?.activado &&
                                            <>
                                                <div className="p-3">
                                                    <p
                                                        className="red-inverse--color font-weight-bold"
                                                        dangerouslySetInnerHTML={{ __html: _.get(textos, coleccion?.extraInformation?.titulo?.translationPath) || coleccion?.extraInformation?.titulo?.default || 'N/A' }}
                                                    ></p>

                                                    <ul className="features-list pt-3">
                                                        {coleccion.extraInformation.detalles.map((element, i) => {
                                                            return (
                                                                <li key={`element-${i}`} dangerouslySetInnerHTML={{ __html: _.get(textos, element?.translationPath) || element?.default || 'N/A' }}></li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>


                                            </>

                                        }
                                        <div className="price-info-new my-3 p-0 mx-0">
                                            <PaymentButton
                                                enableBuyButton={true}
                                                discount={coleccion?.descuento}
                                                price={coleccion?.precio}
                                                onClick={() => {
                                                    ReactPixel.trackCustom('CompraPlan', {name:coleccion?.nombre?.default});
                                                    paymentHandler.openPaymentPage({data:myCollection});
                                                }} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mobile-accordion">
                            {QuestionAccordion()}
                        </div>
                    </div>
                </div>

            </>
        )
    }

    return (
        <section aria-labelledby={titleId}>
            <Breadcrumbs.Box className={'plCasa-breadcrums  p-3'}>
                <Breadcrumbs.Crumb
                    className={`crumb una-linea-texto`}
                    activeClassName={'current'}
                    name={textos?.individual?.mi_coleccion?.breadcrumb_1 || 'Leer en MakeMake'}
                    url={`/tienda/plan-casa?tipo=${tipoColeccion}`} />
                <Breadcrumbs.Crumb
                    className={`crumb una-linea-texto`}
                    activeClassName={'current'}
                    name={textos?.individual?.mi_coleccion?.breadcrumb_2 || 'Mi colección'}
                    url={'/tienda/plan-casa/mi-coleccion'}
                    last={true} />
            </Breadcrumbs.Box>

            {mostrarContenido}
        </section>
    )
}
